var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('single-test-result',{attrs:{"test":_vm.test,"response":_vm.response,"is-public":false}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }